// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"2219359c","258":"01662cfb","377":"39b367c2","417":"3fb6e7ef","467":"f25eea13","626":"e5e40771","870":"d8a8ddbe"}[chunkId] + ".js";
};